import type { Transaction, TransactionOverride } from '@/types/asset-import.types';

export function convertTransactionEditsToOverrides(
  transactionEdits: Map<string, Partial<Transaction>>
): Record<string, TransactionOverride> {
  const transactionOverrides: Record<string, TransactionOverride> = {};
  
  transactionEdits.forEach((edits, txId) => {
    transactionOverrides[txId] = {
      assetCode: edits.editedAssetCode,
      description: edits.description,
      category: edits.category,
      splitIntoIndividual: edits.splitIntoIndividual,
    };
  });
  
  return transactionOverrides;
}
